import  { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const Banner = () => {
    const [ loopNum, setLoopNum ] = useState(0);
    const [ isDeleting, setIsDeleting ] = useState(false);
    const [ text, setText ] = useState('');
    const [ delta, setDelta ] = useState(300 - Math.random() * 100);
    const [ index, setIndex ] = useState(1);
    const listOfText = [
        "I am Okoroafor Kelechi Divine, a multi-tasking Junior " +
        "Java fullstack engineer from Nigeria."
    ];
    const period = 100;
    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => { clearInterval(ticker) };
    }, [ text ])

    const tick = () => {
        let index = loopNum % listOfText.length;
        let fullText = listOfText[index];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setIndex(prevIndex => prevIndex - 1);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setIndex(1);
            setDelta(500);
        } else {
            setIndex(prevIndex => prevIndex + 1);
        }
    }

    return (
        <section className={"banner"} id={"home"}>
            <Container>
                <Row className={"align-items-center"}>
                    <Col xs={ 12 } md={ 6 } xl={ 7 }>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <span className={"tagline"}>Welcome, my friend!</span>
                                    <h1>
                                        <span className={"txt-rotate"} dataPeriod={"10"} data-rotate='[ "" ]'>
                                            <span className={"wrap"}>{ text }</span>
                                        </span>
                                    </h1>
                                    <p>
                                        I develop scalable web based applications and software.
                                        I code within required coding standards and styles to serve the exact need.
                                    </p>
                                    <button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={ 25 } /></button>
                                </div>}
                        </TrackVisibility>
                    </Col>
                    <Col xs={ 12 } md={ 6 } xl={ 5 }>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                                    <img src={ headerImg } alt={"Header Img"}/>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default Banner;